import {net} from "@/request/index";

// 获取视频列表的方法
export const getVideoList = ({ pageIndex, pageSize, filter }) => {
    // 设置参数
    let params = new URLSearchParams()
    // 分页信息
    params.append('pageIndex', pageIndex)
    params.append('pageSize', pageSize)
    // 筛选条件
    params.append('filter', JSON.stringify(filter))
    return net.request({
        params: {},
        data: params,
        method: 'post',
        url: '/admin/get/video/list',
    })
}

// 编辑视频的方法
export const editVideoInfo = ({ videoInfo }) => {
    // 设置参数
    let params = new URLSearchParams()
    params.append('videoInfo', JSON.stringify(videoInfo))
    return net.request({
        params: {},
        data: params,
        method: 'post',
        url: '/admin/edit/video',
    })
}
